import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoaderService } from './services/loader.service';
import * as AOS from 'aos';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'NHRDF';
  loaderLoading: boolean = false;

  constructor(
    private loaderServeice: LoaderService,
    private cdRef: ChangeDetectorRef,
    private router: Router
  ) {
    this.loaderServeice.updateClose.subscribe((message) => {
      setTimeout(() => {
        this.loaderLoading = message;
      });
    });
    AOS.init({
      duration: 800, // Animation duration in milliseconds
      easing: 'ease-in-out', // Easing function
      once: true, // Animation happens only once
    });

      this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects;

        // Disable AOS on specific routes
        if (currentRoute.includes('/register/client')) {
          AOS.init({ disable: true });
        } else {
          AOS.init({ disable: false });
          AOS.refresh(); // refresh for new DOM
        }
      }
    });

    console.log(window.location.href.includes('/register/client'));
  }
}
